/* global mzFunc mzMenu mzTabs */

import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import ReactHtmlParser from 'react-html-parser';

import { get360Data, getLoading, showCmsHiddenBlock, getCmsAwardsBlockFromCMS, showCmsFooterHiddenBlock, getProvince } from '../../../utils';

import { openModal, scrollTo } from '../../../Helpers/helpers';
//import SummaryCalculator from '../../../Helpers/summarycalculator';
import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import GTMHelper from '../../../Helpers/gtmHelper';
import NavHelper from '../../../Helpers/navhelper';

import Button from '../../1_Atoms/Button/Button';
import { Svg } from '../../1_Atoms/Svg/Svg';
import CollapseLegal from '../../2_Molecules/Collapse/CollapseLegal';
import { Nav } from '../../3_Organisms/Nav/Nav';
import { Financial } from '../../3_Organisms/Financial/Financial';
import { BuildSpecs } from '../../3_Organisms/BuildSpecs/BuildSpecs';
import ThreeSixtyContainer from '../../3_Organisms/360Container/360Container';
import { Accessories } from '../../3_Organisms/Accessories/Accessories';
import { FeaturedSpecs } from '../../3_Organisms/FeaturedSpecs/FeaturedSpecs';
import { Packs } from '../../3_Organisms/Packs/Packs';
import { Modal } from '../../3_Organisms/Modal/Modal';

export const SummaryPage = ({ ...props }) => {
    const [loading, setLoading] = useState(true);
    const summaryCalculator = window.summaryCalculator;
    const { year, carline, trim, model, packageCode } = useParams();
    const [nav, setNav] = React.useState(null);
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(['summary', 'general']);
    const buildSpecsRef = useRef(null);

    const [hasScrolled, setHasScrolled] = React.useState(false);

    const [openCollapsable, setOpenCollapsable] = React.useState(null);
    const [openSpecificationCollapsable, setOpenSpecificationCollapsable] = React.useState(null);

    const legalContent = JSON.parse(sessionStorage.getItem(Constants.LegalSummary));
    const [legalModalOpen, setLegalModalOpen] = React.useState(false);

    const [dealerID, setDealerID] = useState(null);
    const [isRetailerMode, setIsRetailerMode] = useState(window.bnp_retailer_mode === true ? true : false);

	const gtmHelper = new GTMHelper();
	const navHelper = new NavHelper();

    //showCmsHiddenBlock(summaryCalculator.selectedVehicle.carline);

    showCmsFooterHiddenBlock();

    summaryCalculator.CurrentStep = 9;

    React.useEffect(() => {
        async function executeTasks() {
            if (!summaryCalculator.isDataLoaded()) {
                await summaryCalculator.loadVehicleData(year, carline, trim, model, packageCode);
                await summaryCalculator.loadFromFinancialProvider();

                if (JSON.parse(sessionStorage.getItem(Constants.HasFinancialProviderError)) === true) {
                    const vehiclePageUri = `/${decodeURI(window.location.search)}`;
                    navigate(vehiclePageUri)
                }

                setLoading(false);

                setNav(null);
            } else {
                setLoading(false);
            }

            if(!loading) {
                if (nav === null) {
                    //setNav(navHelper.getNavContent(year, carline, trim, model, packageCode,summaryCalculator.CurrentStep, t));
                    const toRender = navHelper.getNavContent(t);
                    setNav(toRender);                    
                }
                if(summaryCalculator.isDataLoaded() && !hasScrolled) {
                    // ONCE THE PAGE DATA IS LOADED ANCHOR TO CONTACT A DEALER
                    if (window.location.href.indexOf('?contactDealer') > 0) {
                        function isFindDealerForm() {
                            const formEl = document.getElementById('contactDealer')
                            if (formEl) {
                                const reactEl = formEl.querySelector('.FormApp');
                                if(reactEl){
                                    document.querySelector('#contactDealer').scrollIntoView({
                                        block: 'end',
                                        behavior: 'smooth'
                                    });
                                }else{
                                    setTimeout(isFindDealerForm, 15);
                                }
                            } else {
                              setTimeout(isFindDealerForm, 15);
                            }
                        }
                        isFindDealerForm();
                    }
    
                    setHasScrolled(true);
                }
            }

			if(typeof mzFunc === 'object' && typeof mzTabs === 'object'){
				mzFunc.waitForEl('.mzBuildandPrice .mz-tabs').then(function(components){mzTabs.init(components);});
                mzMenu.init();
			}

            // Set the retailer mode (Force this call for the hotlink situation)
            const isRetailerMode = await summaryCalculator.isRetailerMode();
            setIsRetailerMode(isRetailerMode);
        }
        executeTasks();
    }, [summaryCalculator, loading]);

    let images = {};

    if (summaryCalculator.SelectedColourExteriorIndex !== 'null' && summaryCalculator.Colours !== null) {
        const { exteriors, interiors } = summaryCalculator.Colours.visual;
        const selectedExterior = Object.entries(exteriors)[summaryCalculator.SelectedColourExteriorIndex][1];
        const selectedInterior = summaryCalculator.SelectedColourInteriorIndex !== 'null' ? interiors[summaryCalculator.SelectedColourInteriorIndex] : null;
        images = get360Data(summaryCalculator.Colours.visual, selectedExterior, selectedInterior);
    }

    React.useEffect(() => {
        if (window.bnp_retailer_mode) {
            // Set the polling until we have a dealer vars with the information set as we should always have the dealer vars information
            const intervalRef = setInterval(()=>{
              const dealerVars = window.summaryCalculator.getDealerVars();
            
              if (dealerVars) {
                setDealerID(dealerVars.dealerId);
        
                clearInterval(intervalRef);
              }
            }, 200);
        } else {
            // Restart React Forms app.
            // Skip if this is the first time loading it because App.js takes care of it.
            if (window.isReactFormsAppLoaded && typeof window.initReactFormsApp === 'function') {
                window.initReactFormsApp();
            }
        }
    }, []);

    React.useEffect(() => {
        if(dealerID) {
            // Restart React Forms app.
            // Skip if this is the first time loading it because App.js takes care of it.
            if (window.isReactFormsAppLoaded && typeof window.initReactFormsApp === 'function') {
                window.initReactFormsApp();
            }
        }
    }, [dealerID, isRetailerMode]);

    const generateStaticVehicleImg = () => {
        if (images) {
            const { imagePath,  imageName } = images;
            const { year, carline, trim } = summaryCalculator.selectedVehicle
            const src = imagePath && imageName ? `${imagePath}${imageName.replace('{index}', 18)}` : '';
            return (
                <img src={src} alt={year + '' + carline + ' ' + trim} />
            )
        }
        return ''
    }

    return (
        <>
        {getLoading(false, t)}
        <div className="mz-summary-page mz-top-nav-spacing">
            <Nav nav={nav} />

            <h6 className='mz-full-width mz-summary__page-title'>{t("build_summary")}</h6>
            <h3 className='mz-full-width mz-summary__page-subtitle'>{t("your")} {ReactHtmlParser(summaryCalculator.VehicleTitle)}</h3>

            <div className="mz-summary__top-vehicle-image">
                {generateStaticVehicleImg()}
            </div>

            <div className="mz-full-width mz-summary__top-actions">
                <button
                    className="reset mz-summary-review-build-btn interactive text--grey"
                    onClick={() => {
                        scrollTo({ y: buildSpecsRef.current, offsetY: 100 });
                        gtmHelper.setGTM({'action':'Sctoll to','scrollto': 'Review Build'}, true, false);
                    }}
                >
                    <span>{t("review_build_specifications")}</span>
                </button>
            </div>
            
            <div style={{marginTop: '25px'}}></div>
                        
            <div className="mz-grey-block">
            { !loading ?
                <Financial
                    openCollapsable={openCollapsable}
                    setOpenCollapsable={setOpenCollapsable}
                /> : null }

                <div id="BNP_AWARDS">
                {ReactHtmlParser(getCmsAwardsBlockFromCMS(summaryCalculator.selectedVehicle.year, summaryCalculator.selectedVehicle.carline))}
                </div>

                <div className="mzReactForms mz-summary--container-forms" id="contactDealer">
                    <input type="hidden" data-mz-form-field-name="formType" value="BookTestDrive"/>
                    {isRetailerMode ?
                        <>
                            <h3 className="mz-summary__form-app-title">{t("take_the")} {ReactHtmlParser(summaryCalculator.VehicleTitle)} {t('test_drive')}</h3>
                            <div className="mz-spacer mz-spacer-s"></div>
                            <input type="hidden" data-mz-form-field-name="dealerId" value={dealerID}/>
                        </>
                    :
                        <>
                            <h3 className="mz-summary__form-app-title">{t("contact_your_local_retailer")}</h3>
                        </>
                    }

                    <input type="hidden" data-mz-form-field-name="formDisclaimer" value={t("form_disclaimer_retailer")}/>                    
                    <input type="hidden" data-mz-form-field-name="modelCode" value={model}/>
                    <input type="hidden" data-mz-form-field-name="modelOption" value={packageCode}/>
                    <input type="hidden" data-mz-form-field-name="isTopSectionHidden" value="true"/>
                    <input type="hidden" data-mz-form-field-name="isEmbeddedOnBnP" value="true"/>
                    <input type="hidden" data-mz-form-field-name="source" value="WF"/>
                    <div className="mz-react-forms-root"></div>
                </div>
            </div>

            <div className="mz-summary--container mz-summary--container-build">
                <BuildSpecs componentRef={buildSpecsRef} />
                <Accessories />
            </div>

            {images?.imagePlaceHolder ? <ThreeSixtyContainer imagePlaceHolder={images.imagePlaceHolder} /> : <ThreeSixtyContainer imagePathInterior={images.imagePathInterior} imagePath={images.imagePath} imageAmount={images.imageAmount} imageName={images.imageName} />}
            
            {sessionStorage.getItem(Constants.SpecificationData) && Object.keys(JSON.parse(sessionStorage.getItem(Constants.SpecificationData))).length > 0 ?
                <div className="mz-grey-block mz-summary--container mz-summary--container-specs">
                    <FeaturedSpecs
                        openCollapsable={openSpecificationCollapsable}
                    />
                </div>
            :''}

            
            

            <Modal modalContent={legalContent} isOpen={legalModalOpen} handleClose={setLegalModalOpen} modalId='legalModal' />
        </div>
        {!window.bnp_retailer_mode &&
            <Packs />
        }
        <div className="mz-summary-page">
            <div className="mz-summary--container mz-summary-warranty">
                <div className="mz-legal mz-mobile">
                    <Button
                        className="mz-btn mz-btn--legal alwaysVisible text--grey"
                        label={t("general:legal")}
                        backgroundColor="grey"
                        colour="grey"
                        icon={true}
                        iconAfter={true}
                        svg_className=""
                        svg_list="plus"
                        size={0.6}
                        onClick={() => {
                            document.querySelector('body').classList.add('disabled');
                            setLegalModalOpen(true);
                            gtmHelper.setGTM({'action':'Open Modal','modal': 'Legal'}, true, false);
                        }}
                    />
                </div>
            </div>
        </div>
        </>
    )
}

export default SummaryPage;